import { toggleDropdown, toggleNavbar } from "./library/navbar.ts";

declare global {
  interface Window {
    toggleDropdown: (event: Event) => void;
  }
}

// Expose the function to the global scope
window.toggleDropdown = toggleDropdown;

// Wait for the DOM to load before attaching the event listener
document.addEventListener("DOMContentLoaded", () => {
  const navbarToggler = document.querySelector(".navbar-toggler");

  if (navbarToggler) {
    navbarToggler.addEventListener("click", toggleNavbar);
  }
});
